var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeIntegrated(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9942_319090",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9942_319090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9 14C11.445 14 11.0367 13.8542 10.675 13.5625C10.3133 13.2708 10.0625 12.8981 9.9225 12.4444H6.3C5.53 12.4444 4.87083 12.1398 4.3225 11.5306C3.77417 10.9213 3.5 10.1889 3.5 9.33333C3.5 8.47778 3.77417 7.74537 4.3225 7.13611C4.87083 6.52685 5.53 6.22222 6.3 6.22222H7.7C8.085 6.22222 8.41458 6.06991 8.68875 5.76528C8.96292 5.46065 9.1 5.09444 9.1 4.66667C9.1 4.23889 8.96292 3.87269 8.68875 3.56806C8.41458 3.26343 8.085 3.11111 7.7 3.11111H4.0775C3.92583 3.56481 3.67208 3.9375 3.31625 4.22917C2.96042 4.52083 2.555 4.66667 2.1 4.66667C1.51667 4.66667 1.02083 4.43981 0.6125 3.98611C0.204167 3.53241 0 2.98148 0 2.33333C0 1.68519 0.204167 1.13426 0.6125 0.680556C1.02083 0.226852 1.51667 0 2.1 0C2.555 0 2.96042 0.145833 3.31625 0.4375C3.67208 0.729167 3.92583 1.10185 4.0775 1.55556H7.7C8.47 1.55556 9.12917 1.86019 9.6775 2.46944C10.2258 3.0787 10.5 3.81111 10.5 4.66667C10.5 5.52222 10.2258 6.25463 9.6775 6.86389C9.12917 7.47315 8.47 7.77778 7.7 7.77778H6.3C5.915 7.77778 5.58542 7.93009 5.31125 8.23472C5.03708 8.53935 4.9 8.90556 4.9 9.33333C4.9 9.76111 5.03708 10.1273 5.31125 10.4319C5.58542 10.7366 5.915 10.8889 6.3 10.8889H9.9225C10.0742 10.4352 10.3279 10.0625 10.6838 9.77083C11.0396 9.47917 11.445 9.33333 11.9 9.33333C12.4833 9.33333 12.9792 9.56019 13.3875 10.0139C13.7958 10.4676 14 11.0185 14 11.6667C14 12.3148 13.7958 12.8657 13.3875 13.3194C12.9792 13.7731 12.4833 14 11.9 14ZM2.1 3.11111C2.29833 3.11111 2.46458 3.03657 2.59875 2.8875C2.73292 2.73843 2.8 2.5537 2.8 2.33333C2.8 2.11296 2.73292 1.92824 2.59875 1.77917C2.46458 1.63009 2.29833 1.55556 2.1 1.55556C1.90167 1.55556 1.73542 1.63009 1.60125 1.77917C1.46708 1.92824 1.4 2.11296 1.4 2.33333C1.4 2.5537 1.46708 2.73843 1.60125 2.8875C1.73542 3.03657 1.90167 3.11111 2.1 3.11111Z",
    fill: "#545556"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIntegrated);
export default __webpack_public_path__ + "static/media/badge-integrated.245acc7d.svg";
export { ForwardRef as ReactComponent };